"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.play = void 0;
var play = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1384 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z"
    }
  }]
};
exports.play = play;